import React from 'react';
import { Alert, Button, Snackbar } from '@mui/material';

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const SessionTimeout = ({ showWarning, timeLeft, onExtend, onClose }) => {
  return (
    <Snackbar
      open={showWarning}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={onExtend}>
            Przedłuż sesję
          </Button>
        }
        onClose={onClose}
      >
        {`Sesja wygaśnie za: ${formatTime(timeLeft)}`}
      </Alert>
    </Snackbar>
  );
};

export default SessionTimeout;
